// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-main[data-v-d537f992] {\n    /*50 = navbar  */\n    min-height: calc(100vh - 50px);\n    position: relative;\n    overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
